import type { FC } from 'react'

import type { SelectOption } from '@/components/Select'
import Select from '@/components/Select'
import { AdverseCreditState } from '@/types/adverseCredit'

const selectOptions: SelectOption<AdverseCreditState>[] = [
  {
    value: AdverseCreditState.satisfied,
    label: 'Satisfied',
  },
  {
    value: AdverseCreditState.active,
    label: 'Active',
  },
]

interface Props {
  selectedValue: AdverseCreditState
  onSelect: (newValue: AdverseCreditState) => void
  disabled?: boolean
}

const StateSelect: FC<Props> = ({ selectedValue, onSelect, disabled }) => (
  <Select
    selectedValue={selectedValue}
    options={selectOptions}
    onSelect={onSelect}
    disabled={disabled}
  />
)

export default StateSelect
